import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import Language, { normalizeLanguage } from '../../types/language';

export default function useLanguage(): Language {
  return useSelector((state: RootState): Language => normalizeLanguage(state.application.language));
}
